import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
    FaUserShield,
    FaCheckCircle,
    FaLeaf,
    FaLightbulb,
    FaBalanceScale,
    FaUsers
} from "react-icons/fa";

const values = [
    {
        icon: <FaUserShield />,
        title: "Farmer Commitment",
        text: "Every decision begins with understanding real farming challenges and field realities.",
    },
    {
        icon: <FaCheckCircle />,
        title: "Quality Responsibility",
        text: "Strict standards across sourcing, formulation, and delivery ensure consistent performance.",
    },
    {
        icon: <FaLeaf />,
        title: "Environmental Care",
        text: "Protecting soil, water, and ecosystems is central to our product philosophy.",
    },
    {
        icon: <FaLightbulb />,
        title: "Innovation Mindset",
        text: "Continuous research and improvement keep us aligned with evolving agricultural needs.",
    },
    {
        icon: <FaBalanceScale />,
        title: "Integrity & Transparency",
        text: "Honest practices and ethical conduct guide all our business relationships.",
    },
    {
        icon: <FaUsers />,
        title: "Growing Together",
        text: "Our success is meaningful only when farmers grow and succeed with us.",
    },
];

const CoreValues = () => {
    return (
        <section className="section core-values-section">
            <Container>

                <div className="section-title fade-up">
                    <h2>Our Core Values</h2>
                    <p>
                        The principles that define our culture, guide our actions,
                        and shape our commitment to agriculture.
                    </p>
                </div>

                <Row>
                    {values.map((item, index) => (
                        <Col lg={4} md={6} className="mb-4 fade-up" key={index}>
                            <div className="value-card">
                                <div className="value-icon">{item.icon}</div>
                                <h4>{item.title}</h4>
                                <p>{item.text}</p>
                            </div>
                        </Col>
                    ))}
                </Row>

            </Container>
        </section>
    );
};

export default CoreValues;
